import { OcpsPolicy, isOcpsPolicyEnabled } from 'owa-ocps-policy-store';
import { isPrivacyRoamingEnabled } from '../utils/isPrivacyRoamingEnabled';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';

export const isAnalyzeContentAllowedByPolicy = (): boolean =>
    isPrivacyRoamingEnabled()
        ? isOcpsPolicyEnabled(
              OcpsPolicy.ExperiencesAnalyzingContent,
              true /* enabledIfUndefined */,
              getGlobalSettingsAccountMailboxInfo()
          )
        : true;
